import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST, FETCH_INCREASE_DEAL_SIZE_CARD_SUCCESS, FETCH_INCREASE_DEAL_SIZE_CARD_FAILURE } from "../../actions/opportunities/increaseDealSizeCardActions";


  const initialState = {
    increaseDealSizeCardLoading: false,
    increaseDealSizeCardData: [],
    increaseDealSizeCardError: null,
  };
  
  const increaseDealSizeCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST:
        return { ...state, increaseDealSizeCardLoading: true , payload: action.payload};
      case FETCH_INCREASE_DEAL_SIZE_CARD_SUCCESS:
        return { ...state, increaseDealSizeCardLoading: false, increaseDealSizeCardData: action.payload };
      case FETCH_INCREASE_DEAL_SIZE_CARD_FAILURE:
        return { ...state, increaseDealSizeCardLoading: false, increaseDealSizeCardError: action.payload };    
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState        
      default:
        return state;
    }
  };
  
  export default increaseDealSizeCardReducer;
  